import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "./Header";
import axios from "axios";
import { PROXY } from './config.js';

function ShowSubCategory() {

    const [searchParams, setSearchParams] = useSearchParams();
    const makename = searchParams.get('makename');
    const modelname = searchParams.get('modelname');
    const modelyear = searchParams.get('modelyear');
    const maincategory = searchParams.get('maincategory');

    console.log("makeName ", makename);
    console.log("modelname ", modelname);
    console.log("modelyear ", modelyear);
    console.log("maincategory ", maincategory);


    const [subcategoryNameList, setSubCategoryNameList] = useState(null)

    const navigate = useNavigate()

    const clickedOnModel = (subcategory) => {

        navigate(`/show_parts_list?makename=${makename}&modelname=${modelname}&modelyear=${modelyear}&maincategory=${maincategory}&subcategory=${subcategory}`)

    }

    const showListOfSubCategory = () => {

        const localStorageGroupSubgroup = localStorage.getItem("autoland_group_and_subgroup")

        if (localStorageGroupSubgroup != null) {

            const filteredArray = JSON.parse(localStorageGroupSubgroup).filter((itemForFilter) => {
                return itemForFilter.label == maincategory
            })
            console.log("filteredArray subcategory", filteredArray)
            setSubCategoryNameList(filteredArray[0].options)
        } else {
            alert("something went wrong please try later")
        }

    }


    useEffect(() => {

        showListOfSubCategory()

    }, [])


    return (
        <div className="ShowModel-root-container">

            <div className="Header-wrapper">
                <Header />
            </div>

            <div className="Show-container p-4">

                <h6>Select Category</h6>

                <div className="Show-container-inner">

                    {
                        subcategoryNameList?.map((item) => {
                            return (
                                <div className="list-item-single" onClick={() => clickedOnModel(item.group)}>
                                   
                                    <img className="make_logo me-2" onError={(e)=>{
                                        e.target.style.display = 'none';
                                    }} src={`${PROXY}group/${item.group.replace(/ +/g, "").trim()}.jpg`} />

                                    <img className="make_logo me-2" onError={(e)=>{
                                        e.target.src = 'ic_no_image_found.svg';
                                    }} src={`${PROXY}group/${item.group.replace(/ +/g, "").trim()}.png`} />
                                    
                                    <p>{item.group}</p>
                                </div>
                            )

                        })
                    }


                </div>

            </div>

        </div>
    )
}

export default ShowSubCategory;